import { Field, FieldWrapper } from '@progress/kendo-react-form';
import React from 'react'; 
import config from '../appconfig/config.json';
import appDetailsData from '../data/persondetailsdata.json';
import { CusFormLabel } from '../validation/Form-Components';
import CusFormTitle from './CusFormTitle';
import MyInfoPersonDetails from './MyInfoPersonDetails';
import PersonCPFHistory from './PersonCPFHistory';
import PersonIncomeCPF from './PersonIncomeCPF';
import PersonResiAddress from './PersonResiAddress';
import helper from '../factory/Helper'

const PersonDtlsPendingPreview = (props) => {
    const { personDetails} = props;

    return(
        <div  style={{paddingBottom:'10px'}}>
            
            <Field component={CusFormLabel} 
                leftLabelId={'lblName'} leftLabelName={appDetailsData.label.n}
                id={'Name'} name={personDetails.myInfo.Person_Name !== null? personDetails.myInfo.Person_Name:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblMno'} leftLabelName={appDetailsData.label.mno}
                id={'Mno'} name={personDetails.myInfo.MobileNumber !== null? personDetails.myInfo.MobileNumber:''} />
        
            <Field component={CusFormLabel} 
                leftLabelId={'lblName'} leftLabelName={appDetailsData.label.em}
                id={'Email'} name={personDetails.myInfo.Email_Address !== null? personDetails.myInfo.Email_Address:''} />
         
        </div>
    )
}

export default PersonDtlsPendingPreview;